<template>
  <tbody>
    <tr v-for="(row, i) in items" :key="i">
      <td>
        {{row.first_name}} {{row.last_name}}
        <small>{{row.account === null ? 'Sin cuenta' : row.account}}</small>
      </td>
      <td></td>
      <td>
        Agencia
        <small>{{row.agency === null || row.agency === '0' || row.agency === 0 ? '(Vacio)' : row.agency}}</small>
      </td>
      <td class="text-xs-right">
        {{row.c_to}}
      </td>
      <td class="text-xs-right">
        <v-chip small :class="{'orange--text':row.status === 'Por programar', 'green--text':row.status === 'Programado' || row.status === 'Valido', 'red--text':row.status === 'Invalido', 'transparent subheading':true}">
          {{row.status}}
          <v-icon class="pl-2" small v-if="row.status === 'Por programar'">fas fa-clipboard-list</v-icon>
          <v-icon class="pl-2" small v-if="row.status === 'Programado'">fas fa-clipboard-check</v-icon>
          <v-icon class="pl-2" small v-if="row.status === 'Valido'">fas fa-check</v-icon>
          <v-icon class="pl-2" small v-if="row.status === 'Invalido'">fas fa-times</v-icon>
        </v-chip>
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  props: ['items'],
};
</script>



// WEBPACK FOOTER //
// src/components/campaign_var/CampaignVarList.vue